//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-3d-product-prices',
  props: {
    prices: {
      type: Object,
      default: () => ({
        original: '',
        discounted: '',
        badge: '',
      }),
    },
  },
  computed: {
    hasPromotion() {
      return this.prices.discounted && this.prices.badge
    },
  },
}
